import type { Ref } from 'vue'
import type { Carousel } from 'vue3-carousel'

export enum NavArrowsDisplayType {
  SHOW = 'show',
  SHOW_ON_HOVER = 'show-on-hover',
  HIDE = 'hide',
}

export enum AutoplayType {
  AUTOPLAY = 'autoplay',
  PAUSE_AUTOPLAY_ON_HOVER = 'pause-on-hover',
  NO_AUTOPLAY = 'no-autoplay',
}

export enum SlideAlignPosition {
  START = 'start',
  END = 'end',
  CENTER = 'center',
}

export enum ArrowPosition {
  OUTSIDE = 'outside',
  WITHIN = 'within',
}

export interface SlideBorder {
  color: string
  activeColor: string
  radius: string
  size: string
  activeSize: string
}

export interface Arrow {
  size: string
  position: ArrowPosition
  displayType: NavArrowsDisplayType
}

export type Breakpoints = { [key: number]: Partial<CarouselConfig> }

export type SnapAlign =
  | 'start'
  | 'end'
  | 'center'
  | 'center-even'
  | 'center-odd'

export type Dir = 'rtl' | 'ltr'

export interface CarouselConfig {
  itemsToShow: number
  itemsToScroll: number
  modelValue?: number
  transition?: number
  throttle: number
  autoplay?: number
  snapAlign: SnapAlign
  wrapAround?: boolean
  pauseAutoplayOnHover?: boolean
  mouseDrag?: boolean
  touchDrag?: boolean
  dir?: Dir
  breakpoints?: Breakpoints
  settings?: Partial<CarouselConfig>
}

export interface Vue3CarouselRef extends InstanceType<typeof Carousel> {
  data: {
    config: {
      itemsToScroll: number
    }
    slidesCount: Ref<number>
    maxSlide: Ref<number>
    currentSlide: Ref<number>
  }
  prev: () => void
  next: () => void
  slideTo: (slideIndex: number) => void
}
